module.exports = __webpack_public_path__ + "static/media/28_B.5e18cfaf.png";